// extracted by mini-css-extract-plugin
export var borderRadius = "_em-4";
export var large = "_em-3";
export var logoContainer = "_em-0";
export var nameLogo = "_em-2";
export var small = "_em-1";